import dayjs from 'dayjs'

import 'dayjs/locale/it'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'

dayjs.extend(utc)
dayjs.extend(timezone)

dayjs.locale('it')

dayjs.tz.setDefault('Europe/Rome')

export default (context, inject) => {
  context.$dayjs = dayjs
  inject('dayjs', dayjs)
}
